import intro from '../pages/intro/page.js';
import outro from '../pages/outro_fact/page.js';
import game from '../pages/roundabout/page.js';

let parent;
let _clb;

const intro_page=()=>intro.show({
	cls:'',
	header:'AROUND THE ROUNDABOUT',
	desc:[
		'You\'re almost at Providence Canyon, Georgia\'s "Little Grand Canyon."',
		'Help other drivers know how to use the roundabout so you can all get there safely. The view will be amazing!'
	],
	clb:game_page,
	parent
});

const game_page=()=>game.show({
	parent,
	clb:outro_page
});

const outro_page=()=>outro.show({
	cls:'roundabout',
	header:'well done!',
	desc:[
		'You successfully navigated the <br>roundabout and made it to <br>Providence Canyon. '
	],
	fact:'There are already over 400 roundabouts in Georgia. More than 250 others are under construction or in development!',
	parent,
	clb:()=>{
		if(_clb) _clb();
		_clb = undefined;
	}
})

const _ext={
	start:({container,clb})=>{
		parent = container;
		_clb=clb;
		intro_page();
	},
	stop:()=>{
		game.hide();
	}
}

export default _ext;
